module.exports = __webpack_public_path__ + "media/images/mobile/abouts/12-d696cc17f2d2b3cc6941124b6133d863.jpg";